import React from 'react'
import { Box, Divider, Typography } from '@mui/material'
import ClientHeader from './ClientHeader/ClientHeader'
import {
  SETTLEMENT_DETAILS_HEADER_CREATED_AT_LABEL,
  SETTLEMENT_DETAILS_HEADER_USER_CODE_LABEL,
  SETTLEMENT_DETAILS_HEADER_USER_LABEL
} from '../constants/settlementDetailsConstants'
import { UI_COLOR_TEXT_ICON } from '../constants/uiColors'

const hasData = value => value !== null && value !== undefined && value !== ''

export default function SettlementDetailContextHeader({
  title,
  settlement = null,
  actions = null,
  showUserLabel = true,
  sx = {}
}) {
  const headerConfig = React.useMemo(
    () => ({
      titleKey: 'user_full_name',
      cards: [
        ...(hasData(settlement?.user_uid)
          ? [
              {
                valueKey: 'user_uid',
                label: SETTLEMENT_DETAILS_HEADER_USER_CODE_LABEL,
                icon: 'badge',
                iconColor: UI_COLOR_TEXT_ICON
              }
            ]
          : []),

        ...(hasData(settlement?.collected_at)
          ? [
              {
                valueKey: 'collected_at',
                label: SETTLEMENT_DETAILS_HEADER_CREATED_AT_LABEL,
                icon: 'event',
                format: 'date',
                iconColor: UI_COLOR_TEXT_ICON
              }
            ]
          : []),
        ...(showUserLabel && hasData(settlement?.user_full_name)
          ? [
              {
                valueKey: 'user_full_name',
                label: SETTLEMENT_DETAILS_HEADER_USER_LABEL,
                icon: 'person',
                iconColor: UI_COLOR_TEXT_ICON
              }
            ]
          : [])
      ]
    }),
    [showUserLabel, settlement]
  )

  return (
    <Box sx={{ mb: 3, ...sx }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          mb: 2
        }}
      >
        <Typography sx={{ fontSize: 18 }}>{title}</Typography>
        {actions && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'flex-start', sm: 'flex-end' },
              flex: { xs: '1 1 100%', sm: '0 0 auto' },
              ml: { sm: 'auto' }
            }}
          >
            {actions}
          </Box>
        )}
      </Box>

      <Divider sx={{ mb: 2.5 }} />

      <ClientHeader data={settlement} config={headerConfig} />
    </Box>
  )
}
